export function resolveRenamedConversationTitle({
  nextTitle,
  currentTitle,
}: {
  nextTitle: string;
  currentTitle: string;
}): string | null {
  const trimmed = nextTitle.trim();

  if (!trimmed || trimmed === currentTitle.trim()) {
    return null;
  }

  return trimmed;
}
